/** English catalog. `ui.*` are interface strings; `col.*`, `grp.*`, `field.*`, `opt.*`, `view.*` label data. */
export const en = {
  // shell
  'ui.dashboard': 'Dashboard',
  'ui.openMenu': 'Open menu',
  'ui.closeMenu': 'Close menu',
  'ui.signOut': 'Sign out',
  'ui.language': 'Language',
  'ui.signedInAs': 'Signed in as {name}',
  'ui.more': 'Related records',
  // common
  'ui.cancel': 'Cancel',
  'ui.back': 'Back',
  'ui.create': 'Create',
  'ui.save': 'Save changes',
  'ui.saving': 'Saving…',
  'ui.saved': 'Changes saved.',
  'ui.delete': 'Delete',
  'ui.edit': 'Edit {name}',
  'ui.actions': 'Actions',
  'ui.new': 'New {name}',
  'ui.records': '{count} records',
  'ui.search': 'Search',
  'ui.searchBy': 'Search by {field}',
  'ui.filterBy': 'Filter by {field}',
  'ui.allOf': 'All {field}',
  'ui.clear': 'Clear',
  'ui.showAll': 'Show all',
  'ui.showing': 'Showing',
  'ui.viewAll': 'View all',
  'ui.previous': 'Previous',
  'ui.next': 'Next',
  'ui.pageOf': 'Page {page} of {total}',
  'ui.pagination': 'Pagination',
  'ui.loading': 'Loading…',
  'ui.select': '— Select —',
  'ui.none': '— None —',
  'ui.yes': 'Yes',
  'ui.no': 'No',
  'ui.readOnly': 'Read only',
  'ui.requiredHint': 'Fields marked * are required.',
  'ui.details': 'Details',
  'ui.addRow': 'Add row',
  'ui.removeRow': 'Remove {field} row {n}',
  'ui.longitude': 'Longitude',
  'ui.latitude': 'Latitude',
  'ui.optionsError': 'Could not load options for this field.',
  'ui.noMatches': 'No matching records',
  'ui.noMatchesHint': 'Try a different search or filter.',
  'ui.noneYet': 'No {name} yet',
  'ui.loadError': 'Could not load records',
  'ui.deleteTitle': 'Delete record?',
  'ui.deleteBody': '"{name}" will be permanently deleted. This cannot be undone.',
  'ui.confirm': 'Confirm',
  'ui.working': 'Working…',
  'ui.deleteAria': 'Delete {name}',
  // login
  'ui.signIn': 'Sign in',
  'ui.signingIn': 'Signing in…',
  'ui.signInHint': 'Use your Wareflex account.',
  'ui.email': 'Email',
  'ui.password': 'Password',
  'ui.loginTitle': 'Logistics operations, one platform.',
  'ui.loginBody': 'Track shipments, manage partners and rate cards, and keep finance in sync.',
  'ui.passwordMin': 'Minimum 8 characters.',
  'ui.passwordKeep': 'Leave blank to keep the current password.',
  // dashboard
  'ui.attention': 'Needs attention',
  'ui.allClear': 'Nothing is overdue or stuck right now.',
  'ui.recentShipments': 'Recent shipments',
  'ui.byStatus': 'Shipments by status',
  'ui.noShipmentsYet': 'No shipments yet',
  'ui.noShipmentsHint': 'Create your first shipment to start tracking operations.',
  'view.overdue-pickup': 'Pickup overdue',
  'view.overdue-pickup.hint': 'Requested pickup has passed and the shipment has not been picked up',
  'view.overdue-delivery': 'Delivery overdue',
  'view.overdue-delivery.hint': 'Past the estimated completion date and still open',
  'view.exceptions': 'Exceptions',
  'view.exceptions.hint': 'On hold, delayed, in customs inspection or completed with issue',
  'view.unbooked': 'Awaiting booking',
  'view.unbooked.hint': 'Draft or order created, not yet confirmed',
  'view.active': 'In progress',
  'view.open': 'Open invoices',
  'view.open.hint': 'Draft, issued or partially paid',
  // form sections
  'sec.booking': 'Booking',
  'sec.schedule': 'Schedule',
  'sec.notes': 'Notes',
  'sec.invoice': 'Invoice',
  'sec.parties': 'Parties',
  'sec.billing': 'Billing',
  'sec.identity': 'Identity',
  'sec.contact': 'Contact',
  'sec.equipment': 'Equipment',
  'sec.vehicle': 'Vehicle and driver',
  'sec.cargo': 'Cargo',
  'sec.stop': 'Stop',
  'sec.more': 'Other details',
  'sec.details': 'Details',
  // hub
  'ui.childAdd': 'Add {name}',
  'ui.childEdit': 'Edit {name}',
  'ui.childNew': 'New {name}',
  'ui.childEmpty': 'No {name} yet.',
  'ui.childRemove': 'Remove {name}',
  'ui.childRows': '{count} to create',
  'ui.childSaveFirst': 'Saved together with the record. If anything is invalid, nothing is created.',
  'ui.childRowTitle': '{name} {n}',
  'ui.childOpen': 'Open',
  'ui.childSystem': 'Recorded automatically when the status changes.',
  'ui.childError': 'Fix the highlighted fields in {name}.',
  'ui.unsaved': 'Unsaved changes',
  'ui.tabOverview': 'Overview',
  'ui.addRelated': 'Add {name}',
  'ui.relatedEmpty': 'No {name} yet.',
  'ui.relatedOpenAll': 'Open in list',
  // errors
  'err.permission': 'You do not have permission to do that.',
  'err.notFound': 'Record not found.',
  'err.fixFields': 'Please fix the highlighted fields.',
  'err.unexpected': 'Unexpected error',
  'err.referenced': 'This record is referenced by other data and cannot be deleted.',
  'err.loginFailed': 'Login failed.',
  'err.badCredentials': 'Incorrect email or password.',
  'err.locked': 'Account temporarily locked after too many attempts. Try again later.',
  'err.signInRetry': 'Could not sign in. Please try again.',
  'err.number': 'Enter a valid number',
  'err.point': 'Enter both longitude and latitude',
  // groups
  'grp.Operations': 'Operations',
  'grp.Finance': 'Finance',
  'grp.Pricing': 'Pricing',
  'grp.Master Data': 'Master data',
  'grp.System': 'System',
  'grp.Other': 'Other',
  // collections: singular / plural
  'col.users': 'User',
  'col.users.plural': 'Users',
  'col.organizations': 'Organization',
  'col.organizations.plural': 'Organizations',
  'col.locations': 'Location',
  'col.locations.plural': 'Locations',
  'col.shipments': 'Shipment',
  'col.shipments.plural': 'Shipments',
  'col.shipment-stops': 'Stop',
  'col.shipment-stops.plural': 'Stops',
  'col.shipment-units': 'Unit',
  'col.shipment-units.plural': 'Units',
  'col.shipment-events': 'Event',
  'col.shipment-events.plural': 'Events',
  'col.shipment-charges': 'Charge',
  'col.shipment-charges.plural': 'Charges',
  'col.invoices': 'Invoice',
  'col.invoices.plural': 'Invoices',
  'col.shipment-documents': 'Document',
  'col.shipment-documents.plural': 'Documents',
  'col.rate-cards': 'Rate card',
  'col.rate-cards.plural': 'Rate cards',
  'col.rate-card-lines': 'Rate card line',
  'col.rate-card-lines.plural': 'Rate card lines',
  // fields
  'field.active': 'Active',
  'field.actualAt': 'Actual time',
  'field.actualCompleteAt': 'Actual completion',
  'field.address': 'Address',
  'field.aliases': 'Aliases',
  'field.amountExVat': 'Amount (excl. VAT)',
  'field.apTotal': 'Payable total',
  'field.arTotal': 'Receivable total',
  'field.billingPeriod': 'Billing period',
  'field.bookingDate': 'Booking date',
  'field.bookingLine': 'Booking line',
  'field.bookingNo': 'Booking no.',
  'field.buyer': 'Buyer',
  'field.cargoStuffingPlace': 'Cargo stuffing place',
  'field.cargoType': 'Cargo type',
  'field.category': 'Category',
  'field.cbm': 'Volume (CBM)',
  'field.charges': 'Charges',
  'field.client': 'Client',
  'field.cargo_id': 'Cargo Id',
  'field.cargo_payload_max': 'Cargo Payload Max',
  'field.cargo_payload_min': 'Cargo Payload Min',
  'field.cargo_type': 'Cargo Type',
  'field.credit_term': 'Credit Term',
  'field.mm': 'Mm',
  'field.month': 'Month',
  'field.transport_type_long': 'Transport Type Long',
  'field.transport_type_short': 'Transport Type Short',
  'field.truck_fee_name': 'Truck Fee Name',
  'field.truck_fee_code': 'Truck Fee Code',
  'field.truck_fee_name_vn': 'Truck Fee Name Vn',
  'field.truck_fee_type': 'Truck Fee Type',
  'field.truck_size': 'Truck Size',
  'field.year': 'Year',
  'field.code': 'Code',
  'field.contact': 'Contact',
  'field.contacts': 'Contacts',
  'field.containerNo': 'Container no.',
  'field.containerOwner': 'Container owner',
  'field.coordinates': 'Coordinates',
  'field.createdAt': 'Created',
  'field.createdBy': 'Created by',
  'field.creditTerm': 'Credit term',
  'field.currency': 'Currency',
  'field.customsDeclarationNo': 'Customs declaration no.',
  'field.dangerous': 'Dangerous goods',
  'field.dangerous_class': 'Dangerous goods class',
  'field.days': 'Days',
  'field.defaultCreditTerm': 'Default credit term',
  'field.destination': 'Destination',
  'field.direction': 'Direction',
  'field.document': 'Document file',
  'field.documentDate': 'Document date',
  'field.documents': 'Documents',
  'field.driverLicense': 'Driver license',
  'field.driverName': 'Driver',
  'field.driverPhone': 'Driver phone',
  'field.email': 'Email',
  'field.equipmentType': 'Equipment type',
  'field.estimatedCompleteAt': 'Estimated completion',
  'field.events': 'Events',
  'field.expiresAt': 'Expires',
  'field.exportCode': 'Export code',
  'field.fee_type': 'Fee type',
  'field.file': 'File',
  'field.financialSummary': 'Financial summary',
  'field.googleMapURL': 'Google Maps link',
  'field.happenedAt': 'Happened at',
  'field.incoterm': 'Incoterm',
  'field.instructions': 'Instructions',
  'field.invoice': 'Invoice',
  'field.invoiceDate': 'Invoice date',
  'field.invoiceNumber': 'Invoice no.',
  'field.invoices': 'Invoices',
  'field.issuer': 'Issuer',
  'field.legalName': 'Legal name',
  'field.lines': 'Lines',
  'field.location': 'Location',
  'field.locations': 'Locations',
  'field.mainPartner': 'Main partner',
  'field.margin': 'Margin',
  'field.mode': 'Mode',
  'field.name': 'Name',
  'field.name_vi': 'Vietnamese name',
  'field.note': 'Note',
  'field.notes': 'Notes',
  'field.number': 'Number',
  'field.organization': 'Organization',
  'field.origin': 'Origin',
  'field.owner': 'Owner',
  'field.payload_max': 'Max payload',
  'field.payload_min': 'Min payload',
  'field.phone': 'Phone',
  'field.plannedAt': 'Planned time',
  'field.quantity': 'Quantity',
  'field.rate': 'Rate',
  'field.rateCard': 'Rate card',
  'field.recipient': 'Recipient',
  'field.remarks': 'Remarks',
  'field.requestedPickupAt': 'Requested pickup',
  'field.restrictions': 'Restrictions',
  'field.roles': 'Roles',
  'field.sealNo': 'Seal no.',
  'field.seller': 'Seller',
  'field.sequence': 'Sequence',
  'field.serviceFeeType': 'Service fee type',
  'field.serviced': 'Serviced',
  'field.shipment': 'Shipment',
  'field.shipmentId': 'Shipment ID',
  'field.shortName': 'Short name',
  'field.size': 'Size',
  'field.source': 'Source',
  'field.sourceDocument': 'Source document',
  'field.status': 'Status',
  'field.stops': 'Stops',
  'field.subtotal': 'Subtotal',
  'field.taxId': 'Tax ID',
  'field.total': 'Total',
  'field.totalAmount': 'Total amount',
  'field.totals': 'Totals',
  'field.transportType': 'Transport type',
  'field.trigger': 'Starts counting from',
  'field.type': 'Type',
  'field.units': 'Units',
  'field.validFrom': 'Valid from',
  'field.validUntil': 'Valid until',
  'field.value': 'Value',
  'field.vatAmount': 'VAT amount',
  'field.vatRate': 'VAT rate',
  'field.vatTotal': 'VAT total',
  'field.vehicleNo': 'Vehicle no.',
  'field.wareflexNote': 'Internal note',
  'field.weightKg': 'Weight (kg)',
  'field.password': 'Password',
  // select option values
  'opt.CFR': 'CFR',
  'opt.CIF': 'CIF',
  'opt.CIP': 'CIP',
  'opt.DAP': 'DAP',
  'opt.DDP': 'DDP',
  'opt.DPU': 'DPU',
  'opt.EXW': 'EXW',
  'opt.FCA': 'FCA',
  'opt.FOB': 'FOB',
  'opt.accounting': 'Accounting',
  'opt.active': 'Active',
  'opt.admin': 'Administrator',
  'opt.air': 'Air',
  'opt.bol': 'Bill of lading',
  'opt.booking': 'Booking',
  'opt.booking-confirmed': 'Booking confirmed',
  'opt.booking-date': 'Booking date',
  'opt.cancelled': 'Cancelled',
  'opt.carrier': 'Carrier',
  'opt.charge': 'Charge',
  'opt.client': 'Client',
  'opt.closed': 'Closed',
  'opt.completed-with-issue': 'Completed with issue',
  'opt.container-drop': 'Container drop-off',
  'opt.container-pickup': 'Container pickup',
  'opt.customer': 'Customer',
  'opt.customs': 'Customs',
  'opt.customs-inspection': 'Customs inspection',
  'opt.delayed': 'Delayed',
  'opt.delivered': 'Delivered',
  'opt.delivery': 'Delivery',
  'opt.delivery-date': 'Delivery date',
  'opt.delivery-receipt': 'Delivery receipt',
  'opt.depot': 'Depot',
  'opt.draft': 'Draft',
  'opt.expected': 'Expected',
  'opt.expired': 'Expired',
  'opt.factory': 'Factory',
  'opt.freight': 'Freight',
  'opt.import': 'Import',
  'opt.in-transit': 'In transit',
  'opt.inactive': 'Inactive',
  'opt.invoice': 'Invoice',
  'opt.invoice-date': 'Invoice date',
  'opt.issued': 'Issued',
  'opt.management': 'Management',
  'opt.manual': 'Manual',
  'opt.multimodal': 'Multimodal',
  'opt.office': 'Office',
  'opt.on-hold': 'On hold',
  'opt.onboarding': 'Onboarding',
  'opt.operations': 'Operations',
  'opt.order-created': 'Order created',
  'opt.other': 'Other',
  'opt.paid': 'Paid',
  'opt.partially-paid': 'Partially paid',
  'opt.partner': 'Partner',
  'opt.payable': 'Payable',
  'opt.picked-up': 'Picked up',
  'opt.pickup': 'Pickup',
  'opt.pickup-scheduled': 'Pickup scheduled',
  'opt.pod': 'Proof of delivery',
  'opt.port': 'Port',
  'opt.pricing': 'Pricing',
  'opt.receivable': 'Receivable',
  'opt.received': 'Received',
  'opt.rejected': 'Rejected',
  'opt.sea': 'Sea',
  'opt.surcharge': 'Surcharge',
  'opt.system': 'System',
  'opt.truck': 'Truck',
  'opt.verified': 'Verified',
  'opt.void': 'Void',
  'opt.wareflex': 'Wareflex',
  'opt.warehouse': 'Warehouse',
  // field descriptions
  'desc.billingPeriod': 'YYYY_MM, e.g. 2026_05',
  'desc.organization': 'Required for client and partner portal users.',
} as const
